import { useMemo } from 'react';
import { SolutionModelSubtype } from '../../../contracts';
import { useCheckout } from '../../../hooks/use-checkout';

export function useCheckoutFlowType() {
  const { checkoutData } = useCheckout();
  const solutionModelSubtype = checkoutData?.checkoutConfigurations.solutionModelSubtype;

  return useMemo(
    () => ({
      isPaymentLinksFlow: solutionModelSubtype === SolutionModelSubtype.PAYMENT_LINKS,
      isSideLoadingFlow: solutionModelSubtype === SolutionModelSubtype.SIDE_LOADING,
      isWebCheckoutFlow: solutionModelSubtype === SolutionModelSubtype.WEB_CHECKOUT,
    }),
    [solutionModelSubtype]
  );
}
